import React from 'react';
import './Pages/PagesCss/Footer.css';
import appleLogo from '../components/assets/apple-store.png'; 
import googleLogo from '../components/assets/google-play.png'; 
import gifLogo from '../components/assets/flogo.png';

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-background">
        <div className="footer-container">
          
          {/* Main Footer Content */}
          <div className="footer-main">
            
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="brand-header">
                <img src={gifLogo} alt="Font-Max Logo" className="brand-logo" />
                <div className="brand-text">
                  <h2 className="brand-name">Font-Max</h2>
                  <span className="brand-subtitle">by D-Tech Studios</span>
                </div>
              </div>
              
              <p className="brand-description">
                Font-Max by D-Tech Studios is a font tool platform designed for effortless typography customization, 
                catering to designers, developers, and enthusiasts.
              </p>
              
              {/* Social Links */}
              <div className="social-section">
  <span className="social-label">Follow Us</span>
  <div className="social-links">
    <a 
      href="https://www.facebook.com/people/D-Tech-Studios/61556107977536" 
      className="social-link" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fab fa-facebook-f"></i>
    </a>
    <a 
      href="https://x.com/D_TechStudios" 
      className="social-link" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fab fa-twitter"></i>
    </a>
    <a 
      href="https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile" 
      className="social-link" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fab fa-linkedin-in"></i>
    </a>
    <a 
      href="https://www.instagram.com/d_techstudios/" 
      className="social-link" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fab fa-instagram"></i>
    </a>
  </div>
</div>

            </div>

            {/* Quick Links */}
            <div className="footer-links">
              <div className="link-group">
                <h4 className="link-title">Tools</h4>
                <ul className="link-list">
                  <li><a href="/FontGenerator" className="link-item">Font Generator</a></li>
                  <li><a href="/FontFinder" className="link-item">Font Finder</a></li>
                  <li><a href="/TextReverse" className="link-item">Text Reverse</a></li>
                  <li><a href="/WordCounter" className="link-item">Word Counter</a></li>
                </ul>
              </div>

              <div className="link-group">
                <h4 className="link-title">Navigation</h4>
                <ul className="link-list">
                  <li><a href="/" className="link-item">Home</a></li>
                  <li><a href="/About" className="link-item">About</a></li>
                  <li><a href="/Contact" className="link-item">Contact</a></li>
                </ul>
              </div> 

              <div className="link-group">
                <h4 className="link-title">Legal</h4>
                <ul className="link-list">
                  <li><a href="/PrivacyPolicy" className="link-item">Privacy Policy</a></li>
                  <li><a href="/TermsCondition" className="link-item">Terms of Service</a></li>
                  <li><a href="/ContentPolicy" className="link-item">Content Policy</a></li>
                  <li><a href="/CookiePolicy" className="link-item">Cookie Policy</a></li>
                  <li><a href="/Disclaimer" className="link-item">Disclaimer</a></li>
                  <li><a href="/sitemap.xml" className="link-item" target="_blank" rel="noopener noreferrer">Sitemap</a></li>
                </ul>
              </div>

              <div className="link-group">
                <h4 className="link-title">Explore Our Platforms</h4>
                <ul className="link-list">
                  <li><a 
        href="https://d-techstudios.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        D-Techstudios
      </a></li>
                  <li><a 
        href="https://aftertaxpay.net" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        AfterTaxPay
      </a></li>
                  <li><a 
        href="https://cryptomux.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        Cryptomux
      </a></li>
                  <li><a 
        href="https://noobtobull.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        NoobToBull
      </a></li>
                  <li><a 
        href="https://creditsiq.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        CreditsIq
      </a></li>
                   <li><a 
        href="https://aipicks.org" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="link-item"
      >
        Aipicks
      </a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <div className="copyright">
                <p className="copyright-text">
                  © {new Date().getFullYear()} Font-Max by D-Tech Studios. All rights reserved.
                </p>
              </div>
              
              <div className="footer-legal">
                <div className="legal-links">
                  <a href="/PrivacyPolicy" className="legal-link">Privacy</a>
                  <span className="link-separator">•</span>
                  <a href="/TermsCondition" className="legal-link">Terms</a>
                  <span className="link-separator">•</span>
                  <a href="/CookiePolicy" className="legal-link">Cookies</a>
                  <span className="link-separator">•</span>
                  <a href="/sitemap.xml" className="legal-link" target="_blank" rel="noopener noreferrer">Sitemap</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;